// @ts-nocheck
const optional = (condition, children) => <div>{condition ? children : ''}</div>;

export default optional;
